import Sidebar from './Sidebar.js';
import "bootstrap/dist/css/bootstrap.min.css";

import { useState } from 'react';

function Orders() {

    const [tableData,setTableData] = useState([[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]); 

    const updateData = async (e) => {

        const selected = e.target.value

        const dataToPass = {
            method: 'POST',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify({'month':selected})
        }

        const dataToPass2 = {
            method: 'GET',
            headers: { 'Content-Type':'application/json' },
        }

        try {
            const resp = await fetch("https://cfryapi.onrender.com/getMonth",dataToPass).then(resp=>resp.json())
            const resp2 = await fetch("https://cfryapi.onrender.com/getMenu",dataToPass2).then(resp=>resp.json())
            
            const newTable = [[resp.order[0],resp2[0].price,resp2[0].cost],[resp.order[1],resp2[1].price,resp2[1].cost],[resp.order[2],resp2[2].price,resp2[2].cost],[resp.order[3],resp2[3].price,resp2[3].cost],[resp.order[4],resp2[4].price,resp2[4].cost]]

            setTableData(newTable)
            
        } catch (error) {
            console.log(error)
        }
        
    }

    return (
        <div className='row'>
            <div className='col-2'>
                <Sidebar selected={'Orders'}/>
            </div>
            <div className='col-10 container d-flex flex-column'>
                <div className='row pt-4 pb-4'>
                    <div className='col-11 sqr'>
                        <select className="form-select selectionBar" onChange={updateData}>
                            <option value={1}>January</option>
                            <option value={2}>February</option>
                            <option value={3}>March</option>
                            <option value={4}>April</option>
                            <option value={5}>May</option>
                            <option value={6}>June</option>
                            <option value={7}>July</option>
                            <option value={8}>August</option>
                            <option value={9}>September</option>
                            <option value={10}>October</option>
                            <option value={11}>November</option>
                            <option value={12}>December</option>
                        </select>
                    </div>
                </div>
                <div className="row pb-4">
                    <div className='col-11 sqr'>
                        <table className="table">
                        <thead>
                            <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Total Orders</th>
                            <th scope="col">Price</th>
                            <th scope="col">Total Price</th>
                            <th scope="col">Cost</th>
                            <th scope="col">Total Cost</th>
                            <th scope="col">Total Profits</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>Cappucino</td>
                            <td>{tableData[0][0]}</td>
                            <td>{tableData[0][1]}</td>
                            <td>{tableData[0][0] * tableData[0][1]}</td>
                            <td>{tableData[0][2]}</td>
                            <td>{tableData[0][0] * tableData[0][2]}</td>
                            <td>{(tableData[0][0] * tableData[0][1])-(tableData[0][0] * tableData[0][2])}</td>
                            </tr>
                            <tr>
                            <td>Espresso</td>
                            <td>{tableData[1][0]}</td>
                            <td>{tableData[1][1]}</td>
                            <td>{(tableData[1][0] * tableData[1][1])}</td>
                            <td>{tableData[1][2]}</td>
                            <td>{(tableData[1][0] * tableData[1][2])}</td>
                            <td>{(tableData[1][0] * tableData[1][1])-(tableData[1][0] * tableData[1][2])}</td>
                            </tr>
                            <tr>
                            <td>Latte</td>
                            <td>{tableData[2][0]}</td>
                            <td>{tableData[2][1]}</td>
                            <td>{(tableData[2][0] * tableData[2][1])}</td>
                            <td>{tableData[2][2]}</td>
                            <td>{(tableData[2][0] * tableData[2][2])}</td>
                            <td>{(tableData[2][0] * tableData[2][1])-(tableData[2][0] * tableData[2][2])}</td>
                            </tr>
                            <tr>
                            <td>Affogato</td>
                            <td>{tableData[3][0]}</td>
                            <td>{tableData[3][1]}</td>
                            <td>{(tableData[3][0] * tableData[3][1])}</td>
                            <td>{tableData[3][2]}</td>
                            <td>{(tableData[3][0] * tableData[3][2])}</td>
                            <td>{(tableData[3][0] * tableData[3][1])-(tableData[3][0] * tableData[3][2])}</td>
                            </tr>
                            <tr>
                            <td>Americano</td>
                            <td>{tableData[4][0]}</td>
                            <td>{tableData[4][1]}</td>
                            <td>{(tableData[4][0] * tableData[4][1])}</td>
                            <td>{tableData[4][2]}</td>
                            <td>{(tableData[4][0] * tableData[4][2])}</td>
                            <td>{(tableData[4][0] * tableData[4][1])-(tableData[4][0] * tableData[4][2])}</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
  }
  
export default Orders;